import styled from 'styled-components'
// import { DeviceTypes } from '../../types/state'

export const MaxWidth = styled.div`
	display: flex;
	justify-content: center;
`

export const Main = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1680px;
	margin-top: 20px;
	align-items: center;
`

export const WinnerContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-top: 25px;
`

export const WinnerText = styled.h1`
	color: white;
	font-weight: 700;
	font-size: 24px;
	text-align: center;
	margin: 0;
`
export const TimeLine = styled.p`
	font-weight: 400;
	font-size: 14px;
	text-align: center;
	color: #ffc20e;
	letter-spacing: 1px;
	margin: 0;
`

export const WinnerWrapper = styled.div`
	display: flex;
	background: #ffffff;
	border: 1px solid #000042;
	border-radius: 8px;
	width: 327.78px;
	height: 69.7px;
	justify-content: space-around;
	align-items: center;
`
export const WinnerDetails = styled.div`
	display: flex;
	flex-direction: column;
`

export const WinnerName = styled.p`
	font-weight: 700;
	font-size: 18px;
	text-align: center;
	color: #1e285b;
	margin: 0;
`
export const WinnerLocation = styled.p`
	font-weight: 500;
	font-size: 12px;
	text-align: center;
	color: #1e285b;
	margin: 0;
`

export const AwardImage = styled.img`
	width: 44px;
	height: 44px;
`
